import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../banner.service";
import * as i2 from "@ngx-translate/core";
export class ErrorHandlerV2Service {
  bannerService;
  translateService;
  reportErrorSubject = new Subject();
  errorMessage;
  constructor(bannerService, translateService) {
    this.bannerService = bannerService;
    this.translateService = translateService;
  }
  // no-explicit-any is needed here because the error object can have any structure
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  handleError(apiError, errorMessageInterpolateParams = {}) {
    this.handleWithCustomError('UI-LIB.API.ERROR.TITLE', apiError, errorMessageInterpolateParams);
  }
  handleErrorWithPrefix(apiError, errorTranslationPrefix,
  // no-explicit-any is needed here because the error object can have any structure
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  errorMessageInterpolateParams = {}) {
    const variables = this.getErrorVariables(apiError);
    const detailedErrorMessage = this.getDetailedErrorMessage(variables, errorTranslationPrefix);
    this.openErrorBanner('UI-LIB.API.ERROR.TITLE', detailedErrorMessage, variables.responseErrorMessage ?? '', {
      url: variables.path,
      ...errorMessageInterpolateParams
    }, variables);
  }
  handleWithCustomError(errorTitleKey, apiError,
  // no-explicit-any is needed here because the error object can have any structure
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  errorMessageInterpolateParams = {}) {
    const variables = this.getErrorVariables(apiError);
    const detailedErrorMessage = this.getDetailedErrorMessage(variables);
    this.openErrorBanner(errorTitleKey, detailedErrorMessage, variables.responseErrorMessage ?? '', {
      url: variables.path,
      ...errorMessageInterpolateParams
    }, variables);
  }
  getErrorVariables(apiError) {
    const variables = {
      responseErrorMessage: '',
      path: '',
      errorCode: '',
      correlationId: null
    };
    variables.responseErrorMessage = apiError.error?.message ?? apiError.message;
    variables.path = this.getRequestPath(apiError);
    variables.errorCode = apiError.error?.errorCode ?? '';
    variables.errorParams = apiError.error?.errorParams;
    variables.correlationId = null;
    if (apiError.headers.has('request-correlation-id')) {
      variables.correlationId = apiError.headers.get('request-correlation-id');
    }
    //TraceId returned in the API response is prioritized since it is coming from the backend
    if (apiError.error?.traceId) variables.correlationId = apiError.error?.traceId;
    return variables;
  }
  getDetailedErrorMessage(errorVariables, prefix) {
    let defaultErrorMessage = this.translateService.instant('UI-LIB.API.ERROR.GENERAL');
    const translationPrefix = prefix ? `${prefix}.` : '';
    const detailedErrorMessageKey = `${translationPrefix}API.ERROR.${errorVariables.errorCode}`;
    const categoryErrorMessageKey = `${translationPrefix}API.ERROR.${this.getErrorCodeCategory(errorVariables.errorCode)}`;
    if (errorVariables.errorCode) {
      const detailedErrorMessage = this.translateService.instant(detailedErrorMessageKey, errorVariables.errorParams);
      const categoryErrorMessage = this.translateService.instant(categoryErrorMessageKey);
      if (detailedErrorMessage != detailedErrorMessageKey) {
        defaultErrorMessage = detailedErrorMessage;
      } else if (categoryErrorMessage != categoryErrorMessageKey) {
        defaultErrorMessage = categoryErrorMessage;
      }
    }
    return defaultErrorMessage;
  }
  getRequestPath(apiError) {
    let requestPath = '';
    if (apiError.error?.path) {
      requestPath = apiError.error?.path;
    } else if (apiError.url) {
      requestPath = new URL(apiError.url).pathname;
    }
    return requestPath;
  }
  getErrorCodeCategory(errorCode) {
    // ErrorCodes have always the following format: <APPINFO>_<CategoryNumber>_<ErrorNumber>
    // examples: GEAID_01_0001, SUPPORT_03_0005 wil return --> GEAID_01, SUPPORT_03
    return errorCode?.substring(0, errorCode?.lastIndexOf('_'));
  }
  openErrorBanner(errorTitleKey, detailedErrorMessage, responseErrorMessage,
  // no-explicit-any is needed here because the error object can have any structure
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  messageInterpolateParams, errorVariables) {
    messageInterpolateParams = {
      ...messageInterpolateParams,
      errorCode: errorVariables.errorCode,
      message: errorVariables.errorCode ? detailedErrorMessage : responseErrorMessage
    };
    const title = this.translateService.instant('UI-LIB.ERROR-DIALOG.TITLE');
    const errorTitle = this.translateService.instant(errorTitleKey, messageInterpolateParams);
    const statusCode = this.translateService.instant('UI-LIB.ERROR-DIALOG.STATUS-CODE.GENERAL', messageInterpolateParams);
    const responseMessage = errorVariables.errorCode ? '. ' + this.translateService.instant('UI-LIB.ERROR-DIALOG.MESSAGE', {
      message: responseErrorMessage
    }) + '. ' : ' ';
    this.errorMessage = title + ': ' + errorTitle + ' ' + statusCode + responseMessage;
    if (errorVariables.correlationId) {
      this.errorMessage = this.errorMessage + this.translateService.instant('UI-LIB.ERROR-DIALOG.CORRELATION-ID', {
        id: errorVariables.correlationId
      });
    }
    console.error(this.errorMessage);
    this.bannerService.add({
      severity: 'error',
      data: {
        hasCloseButton: true,
        hasBannerButton: true,
        bannerButtonLabel: this.translateService.instant('UI-LIB.ERROR-DIALOG.REPORT-ERROR'),
        bannerButtonClicked: this.reportError.bind(this)
      },
      detail: title + ': ' + (errorVariables.errorCode ? detailedErrorMessage : errorTitle)
    });
  }
  reportError() {
    this.reportErrorSubject.next(this.errorMessage || '');
  }
  static ɵfac = function ErrorHandlerV2Service_Factory(t) {
    return new (t || ErrorHandlerV2Service)(i0.ɵɵinject(i1.BannerService), i0.ɵɵinject(i2.TranslateService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ErrorHandlerV2Service,
    factory: ErrorHandlerV2Service.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ErrorHandlerV2Service, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.BannerService
  }, {
    type: i2.TranslateService
  }], null);
})();
